import { PureComponent } from 'react';

import {
  makeSelectDeletingDevices,
  makeSelectDiscoveryAddScheduled,
  makeSelectDiscoveryRefreshScheduled,
} from 'containers/App/Header/JobManagement/selectors';
import { clearInventory, fetchDevices } from '../actions';
import {
  makeSelectAddLoader,
  makeSelectContentSnapshot,
  makeSelectDeleteDeviceSnapshotId,
  makeSelectDevices,
  makeSelectDisableStartBtn,
  makeSelectFetchDevicesLoader,
  makeSelectRefreshLoader,
} from '../selectors';

import { isNonNullable } from '@ipfabric/utils';
import { LoaderAndText } from 'containers/LoaderAndText/LoaderAndText';
import { List } from 'immutable';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import RunningTable from './RunningTable';
import { SnapshotInventory } from './SnapshotInventory';

export const columns = [
  'select',
  'hostname',
  'siteName',
  'sn',
  'vendor',
  'family',
  'version',
  'platform',
  'model',
];
const runningTableIgnoredColumns = ['select', 'siteName', 'model'];

class Inventory extends PureComponent {
  static propTypes = {
    addLoader: ImmutablePropTypes.map.isRequired,
    addScheduled: PropTypes.bool.isRequired,
    deletingDevices: PropTypes.bool.isRequired,
    deleteDevicesSnapshotId: PropTypes.string,
    fetchDevicesLoader: ImmutablePropTypes.map.isRequired,
    hostnameTableDetailMsg: PropTypes.object.isRequired,
    inventoryDevices: ImmutablePropTypes.list.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isRunning: PropTypes.bool.isRequired,
    msg: PropTypes.object.isRequired,
    newSnapshot: PropTypes.bool.isRequired,
    recalculating: PropTypes.bool,
    refreshLoader: ImmutablePropTypes.map.isRequired,
    refreshScheduled: PropTypes.bool.isRequired,
    scheduledJob: PropTypes.bool.isRequired,
    selectedSnapshot: PropTypes.string,
    snapshot: ImmutablePropTypes.map,
    snapshotId: PropTypes.string,
    snapshotsMsg: PropTypes.object,
    onClearInventory: PropTypes.func.isRequired,
    onFetchDevices: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { isRunning, onFetchDevices, snapshot } = this.props;
    if (isRunning && !snapshot.get('preventDeviceLoad')) {
      if (!snapshot.get('preventDeviceLoad')) {
        onFetchDevices({ loader: true });
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      isRunning,
      onFetchDevices,
      snapshotId,
      onClearInventory,
      isLoading,
      snapshot,
    } = this.props;
    if (snapshotId !== prevProps.snapshotId && !isRunning) {
      onClearInventory({ snapshotId: prevProps.snapshotId });
    }
    if (
      snapshotId !== prevProps.snapshotId &&
      (isRunning || isLoading) &&
      !snapshot.get('preventDeviceLoad')
    ) {
      onFetchDevices({ loader: true });
    }
  }

  componentWillUnmount() {
    const { onClearInventory, snapshotId } = this.props;
    onClearInventory({ snapshotId });
  }

  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: legacy code
  render() {
    const {
      msg,
      inventoryDevices = new List(),
      isLoading,
      isRunning,
      newSnapshot,
      scheduledJob,
      hostnameTableDetailMsg,
      snapshotsMsg,
      selectedSnapshot,
      snapshotId,
      deleteDevicesSnapshotId,
      fetchDevicesLoader,
      recalculating,
      addLoader,
      addScheduled,
      refreshLoader,
      refreshScheduled,
      deletingDevices,
    } = this.props;
    const emptyRunningData = inventoryDevices.size === 0;
    if (refreshScheduled || refreshLoader.get(snapshotId)) {
      return (
        <div className='snapshots-content__tabs-content-wrapper relative flex flex-1 flex-col'>
          <div className='snapshots-content__tabs-box-body flex flex-1 flex-col'>
            <LoaderAndText
              text={get(msg, 'refreshLoader.text')}
              bottomText={get(msg, 'refreshLoader.bottomText')}
            />
          </div>
        </div>
      );
    }
    if (addScheduled || addLoader.get(snapshotId)) {
      return (
        <div className='snapshots-content__tabs-content-wrapper relative flex flex-1 flex-col'>
          <div className='snapshots-content__tabs-box-body flex flex-1 flex-col'>
            <LoaderAndText bottomText={get(msg, 'addLoader.bottomText')} />
          </div>
        </div>
      );
    }
    if (
      deletingDevices ||
      (isNonNullable(deleteDevicesSnapshotId) &&
        deleteDevicesSnapshotId === snapshotId)
    ) {
      return (
        <div className='snapshots-content__tabs-content-wrapper relative flex flex-1 flex-col'>
          <div className='snapshots-content__tabs-box-body flex flex-1 flex-col'>
            <LoaderAndText
              text={get(msg, 'deleteLoader.text')}
              bottomText={get(msg, 'deleteLoader.bottomText')}
            />
          </div>
        </div>
      );
    }
    if (fetchDevicesLoader.get(snapshotId)) {
      return (
        <div className='snapshots-content__tabs-content-wrapper relative flex flex-1 flex-col'>
          <div className='snapshots-content__tabs-box-body flex flex-1 flex-col'>
            <LoaderAndText />
          </div>
        </div>
      );
    }
    return (
      <div className='flex flex-1 flex-col'>
        {isRunning && emptyRunningData && !recalculating ? (
          <div className='snapshots-content__tabs-content-wrapper relative flex flex-1 flex-col'>
            <div className='snapshots-content__tabs-box-body flex flex-1 flex-col'>
              <h3>
                {isLoading
                  ? get(snapshotsMsg, 'discovery.loadingSnapshot')
                  : get(snapshotsMsg, 'discovery.inProgress')}
              </h3>
              <p>
                {get(
                  msg,
                  isLoading ? 'noDevicesLoaded' : 'noDevicesDiscovered',
                )}
              </p>
            </div>
          </div>
        ) : null}
        {isRunning && !newSnapshot ? (
          <RunningTable
            columns={columns.filter(
              (column) => !runningTableIgnoredColumns.includes(column),
            )}
            data={inventoryDevices}
            disableFooter
            hostnameTableDetailMsg={hostnameTableDetailMsg}
            isRunning={isRunning}
            msg={msg}
            selectedSnapshot={selectedSnapshot}
            showEmptyTable={scheduledJob}
            snapshotId={snapshotId}
            snapshotsMsg={snapshotsMsg}
            tableTitle={get(msg, 'tableTitle')}
          />
        ) : null}
        {(!isRunning && !isLoading && !newSnapshot) ||
        (recalculating && !isRunning) ? (
          <div className='snapshots-content__tabs-content-wrapper flex flex-1 flex-col'>
            <SnapshotInventory />
          </div>
        ) : null}
        {newSnapshot ? (
          <div className='snapshots-content__tabs-content-wrapper relative flex flex-1 flex-col'>
            <div className='snapshots-content__tabs-box-body flex flex-1 flex-col'>
              <h3>{get(msg, 'noDevices')}</h3>
              <p>{get(msg, 'runDiscovery')}</p>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  inventoryDevices: makeSelectDevices(),
  isStartBtnDisabled: makeSelectDisableStartBtn(),
  snapshot: makeSelectContentSnapshot(),
  refreshLoader: makeSelectRefreshLoader(),
  deleteDevicesSnapshotId: makeSelectDeleteDeviceSnapshotId(),
  addLoader: makeSelectAddLoader(),
  fetchDevicesLoader: makeSelectFetchDevicesLoader(),
  addScheduled: makeSelectDiscoveryAddScheduled(),
  refreshScheduled: makeSelectDiscoveryRefreshScheduled(),
  deletingDevices: makeSelectDeletingDevices(),
});

function mapDispatchToProps(dispatch) {
  return {
    onFetchDevices: (args) => dispatch(fetchDevices(args)),
    onClearInventory: (args) => dispatch(clearInventory(args)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Inventory);
